import styled from 'styled-components';

export const CellContent = styled.div`
  margin: 0;
`;
